import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, ElementRef } from '@angular/core';
import { AppTokenHandler, HTTPStatus } from './common/app-token-handler';
import { CommonModule} from '@angular/common';
import {  NavigationStart, Router, RouterModule } from '@angular/router';
import { AlertComponent } from './out-of-application/alert/alert.component';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    // standalone:true,
    // imports:[CommonModule,RouterModule,AlertComponent]
})
export class AppComponent implements OnInit, AfterViewChecked {
    userName: string;
    iSLoading: boolean;
    

    constructor(private cdRef: ChangeDetectorRef, private httpStatus: HTTPStatus,
      private idle: Idle, private router: Router, private _elementRef: ElementRef, private route: Router,  private appToken: AppTokenHandler
    ) {
        this.httpStatus.getHttpStatus().subscribe((status: boolean) => { this.iSLoading = status; });
        this.checkIdleTime(idle)

    }
   


  
  
    ngOnInit() {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
          history.pushState(null, '', window.location.href);
          this.router.navigate(['/logout']);
        }
      });

      this._elementRef.nativeElement.removeAttribute("ng-version");
  
    }
  
    checkIdleTime(idle: Idle) {
      // sets an idle timeout of 5 seconds, for testing purposes.
      idle.setIdle(1800); //--Idle time set for 3600 seconds = 60 mins
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      idle.onIdleStart.subscribe(() => {
        this.logout();
      });
      this.reset();
    }
  
  
  
    logout(){
      this.route.navigate(['/logout']);
     }
     
     reset() {
       this.idle.watch();
     }

    ngAfterViewChecked() {
        this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
          this.iSLoading = status;
        });
        this.cdRef.detectChanges();
      }
}
